
import { Vue, Component } from 'vue-property-decorator'
import SimpleTable from '@/components/busi/table/simple-table.vue'
import Fee from './detail/fee.vue'
import { feesInfo, feesList, feesListCout } from '@/api/ordercenter'
import util from '@/utils/busi/util'

@Component({
  name: 'feedetail',
  components: {
    SimpleTable,
    Fee
  }
})

export default class FeeDetail extends Vue {
  private params = util.getRouterParams()

  private tableData = {
    list: [],
    totalCount: 0
  }

  private pagination = {
    currentPage: 1,
    pageSize: 10
  }

  private loading = !1

  private columns = [
    {
      prop: 'billNo',
      label: '流水号'
    },
    {
      prop: 'receivableAmount',
      label: '应收'
    },
    {
      prop: 'payAmount',
      label: '实收'
    },
    {
      prop: 'payType',
      label: '付款方式'
    },
    {
      prop: 'tradeTypeName',
      label: '收费类型'
    },
    {
      prop: 'createName',
      label: '操作人员'
    },
    {
      prop: 'payTime',
      label: '缴费时间',
      format: 'date'
    },
    {
      prop: 'remark',
      label: '单据摘要'
    },
    {
      prop: 'statusName',
      label: '单据状态'
    }
  ]

  private detailData = {}

  beforeMount () {
    this.initData()
  }

  private async initData (pagination: any = null) {
    this.loading = !0
    await feesList({
      lbSignupId: this.params.id,
      ...pagination || this.pagination
    }).then(async (res: any) => {
      if (res.code === 10000) {
        await feesListCout({
          lbSignupId: this.params.id
        }).then(async (cntRes: any) => {
          if (res.code === 10000) {
            this.tableData.list = res.object.list.map((v: any) => {
              // 新接口，金額單位為分
              v.receivableAmount = v.receivableAmount / 100
              v.payAmount = v.payAmount / 100
              return v
            })
            this.tableData.totalCount = cntRes.object.totalCount
            this.loading = !1
          }
        })
      }
    })
    this.loading = !1
  }

  private dialogVisible = !1

  private rowDbClick (row: any) {
    this.showDetail(row)
  }

  private async showDetail (row: any) {
    await feesInfo({
      payRecordId: row.id
    }).then((res: any) => {
      if (res.code === 10000) {
        this.detailData = res.object
      }
    })
    this.dialogVisible = !0
  }
}
